<template>
  <g>
    <defs>
      <path
        id="zona-1-copy-a"
        d="M7.9951,-0.0003 C12.4031,-0.0003 15.9881,3.5867 15.9881,7.9947 C15.9881,12.4027 12.4031,15.9887 7.9951,15.9887 C3.5861,15.9887 0.0001,12.4027 0.0001,7.9947 C0.0001,3.5867 3.5861,-0.0003 7.9951,-0.0003 Z M7.9951,1.0997 C4.1931,1.0997 1.0991,4.1927 1.0991,7.9947 C1.0991,11.7957 4.1931,14.8887 7.9951,14.8887 C11.7961,14.8887 14.8891,11.7957 14.8891,7.9947 C14.8891,4.1927 11.7961,1.0997 7.9951,1.0997 Z M7.9941,5.4444 C9.4001,5.4444 10.5441,6.5884 10.5441,7.9944 C10.5441,9.4004 9.4001,10.5444 7.9941,10.5444 C6.5881,10.5444 5.4441,9.4004 5.4441,7.9944 C5.4441,6.5884 6.5881,5.4444 7.9941,5.4444 Z M7.9941,6.5444 C7.1951,6.5444 6.5441,7.1944 6.5441,7.9944 C6.5441,8.7934 7.1951,9.4444 7.9941,9.4444 C8.7931,9.4444 9.4441,8.7934 9.4441,7.9944 C9.4441,7.1944 8.7931,6.5444 7.9941,6.5444 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <use
        :fill="currentColor"
        :opacity="opacity"
        transform="translate(4 4)"
        xlink:href="#zona-1-copy-a"
      />
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>